import { render, staticRenderFns } from "./listSegment.vue?vue&type=template&id=44c1f518&"
import script from "./listSegment.vue?vue&type=script&lang=js&"
export * from "./listSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports